
/**
 * @file
 * Предоставляет функции необходимые для работы боковой панели.
 */
 (function (Drupal, once, $, cookie) {

  'use strict';
const sideBarWidth = "300px";
const collapsedSideBarWidth = "30px";

/**
 * обработчик события нажатия на "#sidebar-visibility-switch". 
 * Минимизирует/разворачивает сайдбар со списком проектов.
 *
 * @param {HTMLElement} btn DOM нажатой кнопки.
 */
 function chSidebarSize(btn) {
    $("#sidebar").toggleClass("sidebar_size_min");
    $(".main").toggleClass("main-sidebar-min");
    $(".sidebar__items","#sidebar").toggleClass("sidebar__items_size_min");
    $(".sidebar__content","#sidebar").toggleClass("sidebar__content_size_min");
    $(btn).toggleClass("sidebar__size-switch_size_min");
    btn.innerText == "<<" ? btn.innerText = ">>" : btn.innerText = "<<";
  }

  window.addEventListener("resize",
  function() {
    $("#sidebar").css('max-height',document.documentElement.clientHeight - 44 + 'px');
    $("#sidebar").css('top',$("#page-toolbar").css('Height'));
  },
  {
    once:false,
    passive:true
  }
);
window.addEventListener("load",
  function() {
    $("#sidebar-size-switch").on("click",function(){
      chSidebarSize(this);
    });
    $("#sidebar").css('max-height',document.documentElement.clientHeight - 44 + 'px');
    $("#sidebar").css('top',$("#page-toolbar").css('Height'));
  },
  {
    once:true,
    passive:true
  }
);

/**
 * Раскрывает список страниц книги в навигационном дереве.
 *
 * @param {HTMLElement} book DOM элемент страницы, содержащий список раскрываемых элементов.
 */
 function togglePage(book) {
  (book.parentNode).children[2].classList.toggle("books-tree__pages_hidden");
  book.classList.toggle("books-tree__pages-switch_pages_visible");
}

Drupal.behaviors.sidebar = {
  attach: function (context, settings) {
    const elements = once('sidebar-once-id', $(".books-tree__pages-switch"));
    $(elements).each(function () {
      $(this).on("click",function(){
        togglePage(this);
      });
    });
  }
};
} (Drupal, once, jQuery, window.Cookies));